// แปลงสถานะการแลกของรางวัลให้เป็นข้อความอ่านง่าย
// อ้างอิง logic เดียวกับ scopeSearch (status_key) ของ backend:
//   success   : (reward_type '1' & status '2') หรือ (reward_type '2' & status '3'/'4')
//   onprocess : (reward_type '1' & status '1') หรือ (reward_type '2' & status '1'/'2')
export const renderRedemptionStatus = (rewardType, status) => {
  const t = String(rewardType);
  const s = String(status);
  const isSuccess =
    (t === '1' && s === '2') || (t === '2' && (s === '3' || s === '4'));
  return isSuccess ? 'สำเร็จ' : 'รอดำเนินการ';
};
